"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOptionIntl = void 0;
const hooks_1 = require("common/hooks");
const hooks_2 = require("common/hooks");
const react_1 = require("react");
const useOptionIntl = (options) => {
    const s = (0, hooks_2.useStringIntl)();
    const [locale] = (0, hooks_1.useContextLocale)();
    const convertedOptions = (0, react_1.useMemo)(() => options.map(({ title, value, icon, tooltip }) => ({
        value,
        title: s(title),
        icon,
        tooltip,
    })), [options, locale]);
    return convertedOptions;
};
exports.useOptionIntl = useOptionIntl;
